const DB_NAME = "imalandia_cart_files_v2";
const DB_VERSION = 1;
const STORE_NAME = "files";

const memoryFiles = new Map();

async function serializeFile(file) {
  return {
    name: file.name || "imagen.jpg",
    type: file.type || "application/octet-stream",
    lastModified: file.lastModified || Date.now(),
    buffer: await file.arrayBuffer(),
  };
}

function deserializeFile(record) {
  return new File([record.buffer], record.name, {
    type: record.type,
    lastModified: record.lastModified,
  });
}

function openDatabase() {
  if (typeof indexedDB === "undefined") {
    return Promise.resolve(null);
  }

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "cartItemId" });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

async function withStore(mode, callback) {
  const db = await openDatabase();

  if (!db) {
    return null;
  }

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, mode);
    const store = transaction.objectStore(STORE_NAME);
    const request = callback(store);

    transaction.oncomplete = () => resolve(request);
    transaction.onerror = () => reject(transaction.error);
  });
}

export async function storeCartItemFiles(cartItemId, files) {
  memoryFiles.set(cartItemId, files);
  const storedFiles = await Promise.all(files.map(serializeFile));

  return withStore("readwrite", (store) =>
    store.put({
      cartItemId,
      files: storedFiles,
      updatedAt: new Date().toISOString(),
    })
  ).catch((error) => {
    console.error("No se pudieron guardar las imagenes del carrito", error);
    throw error;
  });
}

export async function getCartItemFiles(cartItemId) {
  const memoryValue = memoryFiles.get(cartItemId);

  if (memoryValue) {
    return memoryValue;
  }

  try {
    const db = await openDatabase();

    if (!db) {
      return [];
    }

    return await new Promise((resolve, reject) => {
      const transaction = db.transaction(STORE_NAME, "readonly");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(cartItemId);

      request.onsuccess = () => {
        const files = (request.result?.files || []).map(deserializeFile);
        memoryFiles.set(cartItemId, files);
        resolve(files);
      };

      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error("No se pudieron leer las imagenes del carrito", error);
    return [];
  }
}

export function removeCartItemFiles(cartItemId) {
  memoryFiles.delete(cartItemId);

  withStore("readwrite", (store) => store.delete(cartItemId)).catch((error) => {
    console.error("No se pudieron borrar las imagenes del carrito", error);
  });
}

export function clearCartItemFiles() {
  memoryFiles.clear();

  withStore("readwrite", (store) => store.clear()).catch((error) => {
    console.error("No se pudieron vaciar las imagenes del carrito", error);
  });
}
